import { UploadFileField } from "@inputs/file";
import { Alert, Button, Typography } from "@mui/material";
import { ErrorBoundary } from "@navigations/ErrorBoundary";
import { useGetCandidateDocumentsSuspense } from "@root/api/services/candidates/getDocuments";
import { Suspense } from "react";
import { Controller } from "react-hook-form";
import type { IAttachmentsWithCandidateDocumentsProps, IAttachmentsWithCandidateDocumentsSuspenseProps } from "./types";

const AttachmentsWithCandidateDocumentsSuspense = ({
  control,
  setAttachmentsLoading,
  getDocuments,
}: IAttachmentsWithCandidateDocumentsSuspenseProps) => {
  const documents = getDocuments();

  return (
    <Controller
      control={control}
      name="attachments"
      render={({ field: { onChange } }) => (
        <UploadFileField
          selectableDocuments={documents}
          onChange={onChange}
          onLoading={setAttachmentsLoading}
          options={{ maxFiles: 5, maxFileSize: 26214400 }}
        />
      )}
    />
  );
};

export const AttachmentsWithCandidateDocuments = ({
  control,
  candidateId,
  setAttachmentsLoading,
}: IAttachmentsWithCandidateDocumentsProps) => {
  const getDocuments = useGetCandidateDocumentsSuspense(candidateId);

  return (
    <ErrorBoundary
      fallback={
        <Alert severity="error" sx={{ alignSelf: "start" }}>
          <Typography variant="body1SemiBold">Oops !</Typography>
          <Typography variant="body1">Une erreur inattendue est survenue</Typography>
        </Alert>
      }
    >
      <Suspense
        fallback={
          <Button variant="outlined" color="primary" size="small" loading disabled sx={{ alignSelf: "start" }}>
            Ajouter une pièce jointe
          </Button>
        }
      >
        <AttachmentsWithCandidateDocumentsSuspense
          control={control}
          setAttachmentsLoading={setAttachmentsLoading}
          getDocuments={getDocuments}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
